import Marquee from "react-fast-marquee";

const items = [
  "Equity Income",
  "Options Hedging",
  "Covered Calls",
  "Fixed Income Ladders",
  "Dividend Systems",
  "Derivatives Overlay",
  "Market-Neutral",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="bg-card py-4 sm:py-5 border-y border-border relative z-10">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 font-display font-extrabold uppercase tracking-tight text-xl sm:text-3xl inline-flex items-center gap-8 text-foreground">
            {t}
            <span className="text-lg sm:text-2xl text-primary">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
